module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/core-js/library/modules/_redefine.js
// module id = 150
// module chunks = 0